export const NON_AUTH_ROUTES = [
  "tv-screen",
  "catalogue/public",
  "lotImageViewer",
];
